// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/auth";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  loginVerify: "/login-verify",
  resetPassword: "/reset-password",
  setnewpassword: "/set-new-password",
  signUp: "/sign-up",
  signUpMobileVerify: "/sign-up-mobile-verify",
  signUpEmailVerify: "/sign-up-email-verify",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  ["business-management"]: {
    root: path(ROOTS_DASHBOARD, "/business-management"),
    business: {
      root: path(ROOTS_DASHBOARD, "/business-management/business"),
      list: path(ROOTS_DASHBOARD, "/business-management/business/list"),
      view: (id: string) =>
        path(ROOTS_DASHBOARD, `/business-management/business/view/${id}`),
    },
    requests: {
      root: path(ROOTS_DASHBOARD, "/business-management/requests"),
      list: path(ROOTS_DASHBOARD, "/business-management/requests/list"),
      view: (id: string) =>
        path(ROOTS_DASHBOARD, `/business-management/requests/view/${id}`),
    },
    connections: path(ROOTS_DASHBOARD, "/business-management/connections"),
  },
  invoices: path(ROOTS_DASHBOARD, "/invoices"),
  accounting: path(ROOTS_DASHBOARD, "/accounting"),
  billing: path(ROOTS_DASHBOARD, "/billing"),
  fee: path(ROOTS_DASHBOARD, "/fee"),
  activity: path(ROOTS_DASHBOARD, "/activity"),
  AdminControl: path(ROOTS_DASHBOARD, "/AdminControl"),
  BankLogs: path(ROOTS_DASHBOARD, "/BankLogs"),
  Chat: (id: string) => path(ROOTS_DASHBOARD, `/Chat/${id}`),
  TicketManagement: {
    root: path(ROOTS_DASHBOARD, "/TicketManagement"),
    list: path(ROOTS_DASHBOARD, "/TicketManagement/list"),
    view: (id: string) => path(ROOTS_DASHBOARD, `/TicketManagement/view/${id}`),
  },
  sales: {
    root: path(ROOTS_DASHBOARD, "/sales"),
    dashboard: path(ROOTS_DASHBOARD, "/sales/dashboard"),
    users: path(ROOTS_DASHBOARD, "/sales/users"),
    addUser: path(ROOTS_DASHBOARD, "/sales/users/add"),
    viewUser: (id: string) => path(ROOTS_DASHBOARD, `/sales/users/view/${id}`),
    editUser: (id: string) => path(ROOTS_DASHBOARD, `/sales/users/edit/${id}`),
    incentivePlan: path(ROOTS_DASHBOARD, "/sales/incentive-plan"),
    incentivePlanAdd: path(ROOTS_DASHBOARD, "/sales/incentive-plan/add"),
    incentivePlanEdit: (id: string) =>
      path(ROOTS_DASHBOARD, `/sales/incentive-plan/edit/${id}`),
    settlement: path(ROOTS_DASHBOARD, "/sales/settlement"),
  },
  affiliate: {
    root: path(ROOTS_DASHBOARD, "/affiliate"),
    AffiliateAnalytics: path(ROOTS_DASHBOARD, "/affiliate/AffiliateAnalytics"),
    list: path(ROOTS_DASHBOARD, "/affiliate/list"),
    tier: path(ROOTS_DASHBOARD, "/affiliate/tier"),
    Settlement: path(ROOTS_DASHBOARD, "/affiliate/Settlement"),
    AffiliatesInvited: (id: string) =>
      path(ROOTS_DASHBOARD, `/affiliate/AffiliatesInvited/${id}`),
  },
  leads: path(ROOTS_DASHBOARD, "/leads"),
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    four: path(ROOTS_DASHBOARD, "/user/four"),
    five: path(ROOTS_DASHBOARD, "/user/five"),
    six: path(ROOTS_DASHBOARD, "/user/six"),
  },
};
